<template>
    <div class="admin-layout">
        <el-header class="admin-header">
            <div class="admin-header-title">总后台管理</div>
            <div class="admin-header-user">
                <span>{{headerShowName}}</span>
                <span class="admin-logout" @click="outLogin">退出</span>
            </div>
        </el-header>

        <el-container class="admin-body">
            <el-aside width="220px" class="admin-sidebar">
                <el-menu
                    :default-active="$route.path"
                    class="admin-menu"
                    text-color="#eae8e8"
                    background-color="#2e315a"
                    active-text-color="#ffffff"
                    :router="true">
                    <HomeLeft
                        v-for="item in menuItems"
                        :key="item.route || item.id"
                        :itemData="item" />
                </el-menu>
            </el-aside>

            <el-main class="admin-main">
                <div v-if="isManufacturerPage" class="manufacturer-page">
                    <div class="manufacturer-toolbar">
                        <el-button size="small" type="primary" @click="handleAdd()">新建</el-button>
                        <Input search enter-button placeholder=" 请输入厂商/账号" v-model="fileNameOrTag" @on-search="getData(1)" style="width: 300px" />
                    </div>
                    <div class="manufacturer-table-wrap">
                        <el-table border :data="tableData" style="width: 100%">
                            <el-table-column prop="name" label="厂商名称"></el-table-column>
                            <el-table-column prop="account" label="账号"></el-table-column>
                            <el-table-column prop="systemName" label="系统名称"></el-table-column>
                            <el-table-column prop="recordInfo" label="备案信息"></el-table-column>
                            <el-table-column prop="" label="操作">
                                <template slot-scope="scope">
                                    <div slot="reference" class="name-wrapper">
                                        <el-link type="primary" @click="handChange(scope.row)">编辑</el-link>
                                        |
                                        <el-link v-if="scope.row.imageId == 0" type="danger" @click="handleDel(scope.row.id,1)">禁用</el-link>
                                        <el-link v-if="scope.row.imageId == 1" type="danger" @click="handleDel(scope.row.id,0)">取消禁用</el-link>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <Page style="float: right;margin-top: 2%" :total="total" :page-size="pageSize" @on-change="getData" />
                    </div>
                </div>
                <router-view v-else></router-view>
            </el-main>
        </el-container>

        <Modal v-model="show" title="添加/编辑" :loading="true" @on-visible-change="visibleChange">
            <el-form ref="form" status-icon :rules="rules" :model="form" label-width="110px" class="demo-ruleForm">
                <el-form-item label="厂商名称" prop="companyName">
                    <el-input size="small" v-model="form.companyName"></el-input>
                </el-form-item>
                <el-form-item label="系统名称" prop="systemName">
                    <el-input size="small" v-model="form.systemName"></el-input>
                </el-form-item>
                <el-form-item label="备案信息" prop="baiseInfo">
                    <el-input size="small" v-model="form.baiseInfo"></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="account">
                    <el-input size="small" v-model="form.account" :disabled="accountStatus"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                    <el-input size="small" v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input size="small" v-model="form.nickname"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input show-password size="small" placeholder="请输入6-16位包含数字和字母的密码" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="sure_password">
                    <el-input show-password size="small" placeholder="请和上面保持一致" v-model="form.sure_password" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <Button type="text" @click="cancel">取消</Button>
                <Button type="primary" @click="submit('form')">确定</Button>
            </template>
        </Modal>
    </div>
</template>

<script>
import HomeLeft from '@/components/components/home/process/comps/AsideComponent/HomeLeft.vue'

export default {
    name: 'MainAdmin',
    components: { HomeLeft },
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            menuItems: [
                { id: 'main-admin-company', menuName: '厂商管理', route: '/mainAdmin', haveChild: 0, isMenu: 1, childList: [] },
                { id: 'main-admin-app-version', menuName: '移动端版本管理', route: '/mainAdmin/appVersionManager', haveChild: 0, isMenu: 1, childList: [] },
                { id: 'main-admin-system-message', menuName: '系统消息管理', route: '/mainAdmin/systemMessageManager', haveChild: 0, isMenu: 1, childList: [] }
            ],
            headerShowName: '',
            isManufacturerPage: true,
            show: false,
            tableData: [],
            fileNameOrTag: '',
            pageSize: 10,
            currentPage: 0,
            total: 0,
            form: { password: '', sure_password: '' },
            rules: {
                companyName: [{ required: true, message: '厂商名称不能为空', trigger: 'blur' }],
                systemName: [{ required: true, message: '系统名称不能为空', trigger: 'blur' }],
                nickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
                phone: [{ required: true, message: '电话号码不能为空', trigger: 'blur' }],
                account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
                password: [{ required: true, message: '密码不能为空', trigger: 'blur' }, { min: 3, message: '密码至少为3位', trigger: 'blur' }],
                sure_password: [{ validator: validatePass2, trigger: 'blur' }]
            },
            accountStatus: false
        }
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                this.isManufacturerPage = path === '/mainAdmin'
            }
        }
    },
    mounted() {
        this.getData(1)
        this.getUserInfo()
    },
    methods: {
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    this.$message.error('请填写完整')
                    return
                }
                const url = this.isAdd === true ? '/mainManager/addBasic' : '/mainManager/update'
                this.componentsMoudel.httpRequest.getRequestHander(url).openLoad().startPost(this.form).then(() => {
                    this.$Message.success('操作成功')
                    this.show = false
                    this.getData(1)
                })
            })
        },
        cancel() {
            this.show = false
        },
        visibleChange(val) {
            if (!val) {
                this.$refs.form.resetFields()
                this.accountStatus = false
            }
        },
        handChange(row) {
            this.isAdd = false
            const data = JSON.parse(JSON.stringify(row))
            this.form = {
                companyName: data.name,
                systemName: data.systemName,
                baiseInfo: data.recordInfo,
                account: data.account,
                nickname: data.nickname,
                password: '',
                id: data.id,
                oldAccount: data.account
            }
            this.show = true
            this.accountStatus = true
        },
        handleDel(id, status) {
            const formData = new FormData()
            formData.append('id', id)
            formData.append('status', status)
            this.componentsMoudel.httpRequest.getRequestHander('/mainManager/changeStatus').openLoad().startPost(formData).then(() => {
                this.$Message.success('操作成功')
                this.getData(1)
            })
        },
        handleAdd() {
            this.isAdd = true
            this.form = { password: '', sure_password: '' }
            this.show = true
        },
        getData(page) {
            const param = { limit: this.pageSize, curPage: page, name: this.fileNameOrTag }
            this.componentsMoudel.httpRequest.getRequestHander('/mainManager/list_all').openLoad().startPost(param).then(res => {
                this.tableData = res.body.data
                this.currentPage = res.body.page
                this.total = res.body.cum
            })
        },
        getUserInfo() {
            this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').userInfo).startGet().then(res => {
                this.componentsMoudel.setData('userData', res.body.data)
                this.headerShowName = '你好 ' + res.body.data.account
            })
        },
        outLogin() {
            this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').outLogin).openLoad().startGet().then(() => {
                this.componentsMoudel.clearLocalStorage()
                this.$router.push({ path: '/' })
            })
        }
    }
}
</script>

<style scoped>
.admin-layout {
    min-height: 100vh;
    padding-top: 56px;
    background: #fff;
    box-sizing: border-box;
}
.admin-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 100vw;
    height: 56px !important;
    line-height: 56px;
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    box-sizing: border-box;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
}
.admin-header-title {
    flex: 0 0 auto;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    white-space: nowrap;
}
.admin-header-user {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 18px;
    height: 56px;
    line-height: 56px;
    font-size: 13px;
    white-space: nowrap;
}
.admin-logout {
    cursor: pointer;
    color: #fff;
}
.admin-logout:hover {
    color: #409eff;
}
.admin-body {
    min-height: calc(100vh - 56px);
}
.admin-sidebar {
    background: #2e315a;
}
.admin-menu {
    min-height: calc(100vh - 56px);
    border-right: none;
    text-align: left;
}
.admin-menu .font_family {
    margin-right: 10px;
}
.admin-menu .el-menu-item.is-active {
    background-color: transparent;
}
.admin-menu .el-menu-item:focus,
.admin-menu .el-menu-item:hover {
    background-color: #001528 !important;
}
.admin-main {
    padding: 20px;
}
.manufacturer-page {
    width: 100%;
}
.manufacturer-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.manufacturer-table-wrap {
    margin-top: 20px;
}
</style>
